module.exports = __webpack_public_path__ + "static/media/TubeStand-new.2e7448c4.svg";